import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import InvertedMobileHomeRightPane from './InvertedMobileHomeRightPane'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden'

// import MenuIcon from '@material-ui/icons/Menu';
// import IconButton from '@material-ui/core/IconButton';
// import { Language } from '@material-ui/icons';



import './header.css'

export default class RightPane extends Component {
  render() {
    return (
      <React.Fragment>
        <Hidden smDown>
          <AnchorLink className={css(styles.AnchorLink)} href="#AppDevelopment" offset="100">
            <Button className={css(styles.MenuButton)}>App Development</Button>
          </AnchorLink>
          <AnchorLink className={css(styles.AnchorLink)} href="#NfcAndIot" offset="-150">
            <Button className={css(styles.MenuButton)}>Nfc & Iot</Button>
          </AnchorLink>
          <AnchorLink className={css(styles.AnchorLink)} href="#BlockChain" offset="-150">
            <Button className={css(styles.MenuButton)}>BlockChain</Button>
          </AnchorLink>
          <AnchorLink className={css(styles.AnchorLink)} href="#Footer" offset="-150">
            <Button className={css(styles.MenuButton)}>Contact</Button>
          </AnchorLink>

        </Hidden>
    {/*    <IconButton className={css(styles.MenuButton)}>
          <Language />
        </IconButton>*/}
        <Hidden smUp>   
          <InvertedMobileHomeRightPane />
        </Hidden>
      </React.Fragment>
    );
  }
}
const styles = StyleSheet.create({
    MenuButton : {
      color: '#4985f2',
      textTransform: 'capitalize'
    },
    AnchorLink: {
      textDecoration: 'none',
    }
});


// WEBPACK FOOTER //
// ./src/Components/Header/InvertedHomeRightPane.js